import { createSlice } from '@reduxjs/toolkit'

const welcomeSlice = createSlice({
  name: 'welcome',
  initialState: { show: false, mapDataReady: false },
  reducers: {
    showWelcome: state => {
      state.show = true
      state.mapDataReady = false
    },
    hideWelcome: state => {
      state.show = false
      state.mapDataReady = false
    },
    setMapDataReady: state => {
      state.mapDataReady = true
    },
  },
})

export const { showWelcome, hideWelcome, setMapDataReady } = welcomeSlice.actions
export default welcomeSlice.reducer
